import React from "react";
import styled from "styled-components";

const Section = styled.section`
  background: #ffce2d;
  padding: 12rem 0rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Container = styled.div`
  background: #fff;
  padding: 3rem 2rem;
  position: relative;
`;

const Wrap = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;
const PoliticaDeConfidentialitate = () => {
  return (
    <Section>
      <Container>
        <Wrap>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h1 style={{ textAlign: "center" }}>
              Politică de confidențialitate
            </h1>
            <p style={{ textAlign: "center", color: "#666", marginTop: "8px", marginBottom: "12px" }}>
              Ultima actualizare: 26 aprilie 2026
            </p>
            <p style={{ textAlign: "center", color: "#666", marginBottom: "20px" }}>
              Operator: Rotaract Club Timișoara · Site:
              {" "}
              <a href="https://timisoara.cursaderatuste.ro" style={{ color: "#faa71e" }}>
                timisoara.cursaderatuste.ro
              </a>
            </p>
            <h3 style={{ margin: "20px 0" }}>
              1. CE INFORMATII COLECTAM DESPRE TINE
            </h3>
            <span>
              Trebuie sa stii ca exista doua tipuri de informatii pe care le
              colectam despre utilizatorii timisoara.cursaderatuste.ro: a) „Informatii cu
              caracter personal” – acele informatii care te pot identifica si
              pot include, de exemplu, numele si prenumele tale, numarul de
              telefon sau adresa de email. b) „Informatii ce nu te pot
              identifica personal” – informatii care se refera, de regula, la
              computerul sau dispozitivul mobil de pe care accesezi serviciile
              timisoara.cursaderatuste.ro, dar care nu te identifica personal. Aceste
              informatii pot include, printre altele, paginile web pe care
              le-ati vizitat, serviciile pe care le-ati accesat, publicitatea
              (reclamele) trimisa catre tine, istoricul tranzactiilor, adresa
              IP, informatii despe conexiunea ta la Internet etc.
            </span>
            <h3 style={{ margin: "20px 0" }}>
              Efectuarea unei achiziții de produse
            </h3>
            <span>
              Dacă faci o achiziție de produse prin timisoara.cursaderatuste.ro, vom
              colecta informațiile de care avem nevoie pentru a finaliza comanda
              ta și te vom notifica despre starea comenzii tale (daca este cazul
            </span>
            <h3 style={{ margin: "20px 0" }}>Informații personale sensibile</h3>
            <span>
              Te rugam sa retii ca timisoara.cursaderatuste.ro poate colecta informații
              personale sensibile in timpul furnizarii de bunuri si / sau
              servicii pentru dumneavoastra (de exemplu: adresa de livrare)
            </span>
            <h3 style={{ margin: "20px 0" }}>
              2. CUM COLECTAM INFORMATIILE DESPRE TINE
            </h3>
            <span>
              Colectam informatii despre tine in trei moduri: a) In mod direct –
              atunci cand va inregistrati pe site-ul timisoara.cursaderatuste.ro; cand va
              abonati la newsletter; cand cumparati produse listate pe site, fie
              online, fie din magazin, atunci cand ne contactati si solicitati
              un raspuns sau atunci cand interactionati in mod direct cu noi. De
              aceea, este foarte important sa retii ca, in cazul in care alte
              persoane folosesc computerul/device-ul tau mobil, trebuie sa te
              deloghezi la finalizarea sectiunii de navigare. In caz contrar,
              orice persoana cu acces la device-urile tale va avea automat acces
              si la toate informatiile pe care ni le-ai furnizat. b) In mod
              automat – atunci cand utilizezi serviciile timisoara.cursaderatuste.ro
              online, colectam informatii prin intermediul cookie-urilor si prin
              logarea activitatii tale. În plus, daca in prealabil ne-ai
              furnizat informatii cu caracter personal, putem asocia automat
              acele informatii cu alte informatii pe care le colectam din contul
              tau de utilizator ori de cate ori te loghezi, astfel încat sa te
              putem identifica pe mai multe dispozitive si browsere, oferindu-ti
              aceeasi experienta de navigare, indiferent de mediul pe care te
              conectezi. Te rugam sa retii faptul ca ne poti cere in orice
              moment sa-ti stergem contul timisoara.cursaderatuste.ro, trimitandu-ne un
              email pe adresa clubrotaract.timisoara@gmail.com. Odata ce ne vei
              cere acest lucru, nu vei mai putea accesa contul tau
              timisoara.cursaderatuste.ro, nici informatile salvate pe baza acestuia. Desi
              contul tau va fi sters, vom pastra anumite informatii doar cu
              scopul de a raspunde eventualelor intrebari/solicitari de orice
              natura, pe care le-ai putea avea in viitor.
            </span>
            <h3 style={{ margin: "20px 0" }}>
              3. CUM UTILIZAM INFORMATIILE DESPRE TINE
            </h3>
            <span>
              Noi (si furnizorii nostri de servicii) putem folosi informatiile
              pe care le colectam despre tine pentru o varietate de scopuri. De
              exemplu, putem folosi aceste informatii: pentru a-ti furniza
              serviciile si produsele pe care le-ai solicitat; pentru
              personalizarea serviciilor pe care ti le oferim; pentru
              personalizarea publicitatii pe care ti-o afisam; pentru a raspunde
              solicitarilor si comentariilor tale; pentru a-ti permite sa
              participi la diferite activitati interactive (ex: concursuri);
              pentru a-ti putea oferi suport tehnic legat de
              serviciile/produsele noastre; pentru a-ti putea comunica anunturi
              si mesaje administrative; pentru a-ti trimite newslettere si
              informatii despre produse, servicii si promotii referitoare la noi
              sau la alte companii sau organizatii cu care lucram; Retine faptul
              ca pentru a primi un newsletter este necesara abonarea (OPT-IN)
              atunci cand efectuezi o comanda sau separat de pe prima pagina a
              siteului pentru a utiliza anumite tehnologii (cum ar fi Audientele
              Personalizate Facebook) prin intermediul carora sa-ti livram
              publicitate pe alte site-uri, bazandu-ne pe Datele Personale
              furnizate de tine sau de terte servicii carora tu le-ai dat acest
              drept; pentru a recunoaste dispozitivele pe care le utilizezi
              atunci cand accesezi timisoara.cursaderatuste.ro si a le asocia profilului
              tau; pentru a-ti trimite comanda (prin curier).
            </span>
            <h3 style={{ margin: "20px 0" }}>
              4. CUM SI CU CINE SCHIMBAM INFORMATII DESPRE TINE
            </h3>
            <span>
              Este posibil sa împartasim tertilor informatii cu caracter
              personal despre tine. Furnizorii de servicii: pentru a îndeplini
              anumite functii legate de activitatea timisoara.cursaderatuste.ro: De
              exemplu, furnizorii nostri de servicii pot oferi servicii cum ar
              fi cercetarea, analiza, gazduirea de site-uri web, realizarea
              tranzactiilor, întretinerea bazelor de date, furnizarea de
              servicii si platforme tehnologice, livrarile si procesarea de
              plati, livrari de colete. În mod obisnuit, atunci cand furnizam
              acestor companii informatii cu caracter personal, avem o deosebita
              grija sa partajam doar acele informatii de care aceste companii au
              nevoie pentru a-si îndeplini functiile, mentionand express ca
              aceste informatii pot fi utilizate numai atunci cand este necesara
              efectuarea de servicii în numele nostru sau pentru a ne conforma
              cerintelor legale. În mod similar, atunci cand este cazul, luam
              masuri pentru a solicita furnizorilor nostri de servicii sa
              protejeze informatiile cu caracter personal transmise. Motive
              juridice: Putem folosi sau dezvalui informatiile, integral sau
              parțial, pentru a coopera sau a sprijini organismele de aplicare a
              legii, guvernamentale sau de reglementare, organizatiile de
              protectie a continutului sau procesele judiciare în legatura cu
              sau pentru a preveni frauda suspectata sau posibila. De asemenea,
              putem folosi sau dezvalui informatii pe care le consideram
              adecvate în masura în care înregistrarile au fost citate sau în
              legatura cu litigiile în curs sau potentiale, sau pentru a impune
              sau a proteja drepturile sau siguranta utilizatorilor de servicii
              online.
            </span>
            <h3 style={{ margin: "20px 0" }}>
              5. INFORMATII SUPLIMENTARE PRIVIND CUM SI CU CINE SCHIMBAM
              INFORMATII DESPRE TINE
            </h3>
            <span>
              Este posibil sa colaboram cu retele terte de publicitate si cu
              companii de studiul pietei, pentru a-ti prezenta reclame prin
              intermediul serviciilor online sau pentru a ne ajuta sa evaluam
              utilizarea serviciilor online, vizualizarea reclamelor si a altui
              tip de continut. Aceste companii terte pot vizualiza, edita sau
              seta propriile tehnologii / cookie-uri de urmarire, ceea ce le va
              permite sa colecteze informatii despre modul în care
              interactionezi cu continutul si publicitatea în timp ce utilizezi
              serviciile timisoara.cursaderatuste.ro. Utilizarea acestor tehnologii de
              catre terte companii este supusa propriilor politici de
              confidentialitate si nu este acoperita de aceasta politica de
              confidentialitate.
            </span>
            <h3 style={{ margin: "20px 0" }}>6. COPII</h3>
            <span>
              Serviciile online nu sunt concepute sau destinate utilizarii de
              catre copiii cu varsta sub 13 ani si, prin urmare, daca ai sub 13
              ani, te rugam sa nu utilizezi serviciile timisoara.cursaderatuste.ro,
              respectiv sa nu ne furnizezi informatii cu caracter personal. Daca
              descoperim ca am adunat din greseala astfel de informatii, atunci,
              în masura în care legea solicita, vom sterge aceste informatii din
              evidentele noastre. Daca un parinte sau tutore descopera ca
              copilul sau cu varsta de pana la 13 ani ne-a furnizat informatii
              fara consimtamantul acestuia, el sau ea ar trebui sa ne contacteze
              la clubrotaract.timisoara@gmail.com.
            </span>
            <h3 style={{ margin: "20px 0" }}>
              7. CUM PROTEJAM INFORMATIILE CU CARACTER PERSONAL
            </h3>
            <span>
              Te asiguram ca mentinem atat procedurile, cat si normele
              tehnice/de acces la serviciile timisoara.cursaderatuste.ro la un standard
              foarte inalt, cu scopul de a-ti proteja datele cu caracter
              personal împotriva pierderii, utilizarii incorecte sau accesului,
              dezvaluirii, modificarii sau distrugerii neautorizate, date pe
              care le furnizezi prin intermediul serviciilor timisoara.cursaderatuste.ro.
              Din pacate, nici o transmitere a datelor nu este garantata ca
              fiind 100% sigura. Este posibil ca terte parti, care nu sunt sub
              controlul nostru sa intercepteze sau sa acceseze în mod ilegal
              transmisii sau comunicatii private. În consecinta, orice
              transmitere a informatiilor cu privire la identitatea personala se
              face pe cont propriu. Daca sesizezi orice neregula si consideri ca
              te putem ajuta, te rugam sa ne soliciti ajutorul la
              clubrotaract.timisoara@gmail.com. Te rugam sa retii ca trebuie sa
              pastrezi confidentiala parola cu care te autentifici pe
              timisoara.cursaderatuste.ro. Informatiile pe care le colectam despre tine pot
              fi transferate sau salvate la destinatii din afara Uniunii
              Europene. De asemenea, pot exista situatii cand prelucrarea
              datelor tale se poate face de catre persoane (angajati ai
              furnizorilor de servicii pentru timisoara.cursaderatuste.ro localizate in
              afara Uniunii Europene. Introducand informatii personale in
              formularele serviciilor timisoara.cursaderatuste.ro esti de acord cu toate
              cele mentionate mai sus, in acest paragraf. Daca crezi ca
              interactiunea ta cu vreunul din serviciile timisoara.cursaderatuste.ro nu mai
              este sigura, contacteaza-ne la clubrotaract.timisoara@gmail.com.
            </span>
            <h3 style={{ margin: "20px 0" }}>
              8. DREPTURILE ȘI ALEGERILE TALE
            </h3>
            <h3 style={{ margin: "20px 0" }}>
              Preferințe de comunicare și opțiuni de dezabonare (OPT-OUT)
            </h3>
            <span>
              Dacă te-ai abonat la unul sau mai multe newslettere si nu mai
              doresti sa le primesti, te poți dezabona. Selecteaza link-ul din
              partea de jos a oricărui mesaj pentru a te dezabona de la
              email-urile de marketing și de promovare.
            </span>
            <h3 style={{ margin: "20px 0" }}>Acces și corectare</h3>
            <span>
              In cazul în care este necesar, oferim vizitatorilor online acces
              la informațiile lor personale și posibilitatea de a le revizui,
              actualiza și corecta. Pentru a te ajuta să-ti protejezi
              confidențialitatea și securitatea, vom lua măsuri rezonabile
              pentru a ti verifica identitatea, cum ar fi solicitarea unei
              parole și a unui cont de utilizator. Vă rugăm să contactați
              clubrotaract.timisoara@gmail.com pentru mai multe informații
              despre exercitarea acestor drepturi.
            </span>
            <h3 style={{ margin: "20px 0" }}>Pastrarea și ștergerea datelor</h3>
            <span>
              Putem păstra datele tale atâta timp cât utilizezi serviciile
              timisoara.cursaderatuste.ro și pentru un timp rezonabil ulterior. Dacă
              doresti să le ștergem, modificam sau actualizam informațiile
              personale pe care le-ai furnizat prin intermediul serviciilor
              timisoara.cursaderatuste.ro, poti utiliza setările din pagina ta de profil
              sau ne poti contacta la clubrotaract.timisoara@gmail.com și iti
              vom răspunde într-un termen rezonabil. Te rugăm să reții că unele
              sau toate aceste date pot fi necesare pentru ca serviciile
              timisoara.cursaderatuste.ro să funcționeze corect și este posibil să fim
              obligați să păstrăm anumite informații prin lege.
            </span>
            <h3 style={{ margin: "20px 0" }}>
              9. ACORD PENTRU PROCESAREA ȘI TRANSFERUL INFORMAȚIILOR DESPRE TINE
            </h3>
            <span>
              Serviciile timisoara.cursaderatuste.ro sunt guvernate și operate în
              conformitate cu legile din Romania. timisoara.cursaderatuste.ro nu ofera
              nicio garantie că Serviciile sale sunt guvernate sau operate în
              conformitate cu legile oricărei alte tari. Dacă vă aflați în afara
              Romaniei, vă rugăm să fiți conștienți de faptul că informațiile
              colectate, inclusiv informațiile cu caracter personal, pot fi
              transferate, procesate, stocate și utilizate în Romania. În
              conformitate cu legislația din Romania, datele tale personale pot
              fi supuse solicitărilor de acces din partea Guvernului,
              Instanțelor sau organelor de drept din Romania.
            </span>
            <h3 style={{ margin: "20px 0" }}>
              10. ACTUALIZAREA POLITICII PRIVIND CONFIDENȚIALITATEA DATELOR
            </h3>
            <span>
              Din când în când, este posibil să revizuim această politică de
              confidențialitate. Dacă facem revizuiri în ceea ce privește modul
              în care colectăm sau folosim datele personale, te vom notifica cu
              privire la aceste modificări prin: (1) anunțarea modificării
              serviciilor timisoara.cursaderatuste.ro sau (2) intreprinderea altor acțiuni,
              după cum considerăm adecvate în aceste circumstanțe, incluzând,
              fără limitare, publicarea online a versiunii revizuite a acestei
              Politici de confidențialitate. Ar trebui să verifici frecvent
              serviciile noastre pentru actualizări sau cel puțin atunci când
              achiziționezi un bilet de pe site. Dacă nu esti de acord cu
              termenii acestei Politici de confidențialitate, în totalitate sau
              în parte, te rugăm să intrerupi utilizarea Serviciile noastre
              online.
            </span>
            <h3 style={{ margin: "20px 0" }}>11. CONTACTEAZA-NE</h3>
            <span>
              Pentru orice întrebări legate de această Politică de
              confidențialitate, te rugăm să ne contactezi la
              clubrotaract.timisoara@gmail.com.
            </span>
          </div>
        </Wrap>
      </Container>
    </Section>
  );
};

export default PoliticaDeConfidentialitate;
